<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success">
      <!-- Card stats -->
      <b-row>
        <b-col xl="3" md="6">
          <stats-card :title="'Current\npercentage'"
                      type="gradient-green"
                      :sub-title="headersLoading ? 'Loading' : headerData.current_percent.value.toString() + ' %'"
                      icon="ni ni-like-2"
                      class="mb-4">

            <template slot="footer" v-if="headersLoading===false">
              <span :class="{'text-success mr-2':headerData.current_percent.increasing === true,'text-danger mr-2':headerData.current_percent.increasing === false}">
                <i :class="{'ni ni-bold-up':headerData.current_percent.increasing === true, 'ni ni-bold-down':headerData.current_percent.increasing === false, 'ni ni-fat-delete' : headerData.current_percent.increasing === null}"/>
                {{headersLoading ? '-' : headerData.current_percent.percent_change + ' %'}}
              </span>
              <span class="text-nowrap">Since last week</span>
            </template>
          </stats-card>
        </b-col>
        <b-col xl="3" md="6">
          <stats-card :title="'Average\npercentage'"
                      type="gradient-orange"
                      :sub-title="headersLoading ? 'Loading' : headerData.average_percent.value.toString() + ' %'"
                      icon="ni ni-like-2"
                      class="mb-4">

            <template slot="footer" v-if="headersLoading===false">
              <span :class="{'text-success mr-2':headerData.average_percent.increasing === true,'text-danger mr-2':headerData.average_percent.increasing === false}">
                <i :class="{'ni ni-bold-up':headerData.average_percent.increasing === true, 'ni ni-bold-down':headerData.average_percent.increasing === false, 'ni ni-fat-delete' : headerData.average_percent.increasing === null}"/>
                {{headersLoading ? '-' : headerData.average_percent.percent_change + ' %'}}
              </span>
              <span class="text-nowrap">Since last week</span>
            </template>
          </stats-card>
        </b-col>
        <b-col xl="3" md="6">
          <stats-card :title="'Site\ncount'"
                      type="gradient-red"
                      :sub-title="headersLoading ? 'Loading' : headerData.site_count.value.toString()"
                      icon="ni ni-single-copy-04"
                      class="mb-4">

            <template slot="footer" v-if="headersLoading===false">
              <span>
                <i class="ni ni-fat-delete"/>
                Next scrape: {{formatDefaultDate(headerData.next_scrape_date)}}
              </span>
              <span class="text-nowrap"></span>
            </template>
          </stats-card>
        </b-col>
        <b-col xl="3" md="6">
          <stats-card :title="'Recent scraped\nsites'"
                      type="gradient-purple"
                      :sub-title="headersLoading ? 'Loading' : headerData.sites_scraped_last_week.value.toString()"
                      icon="ni ni-shop"
                      class="mb-4">

            <template slot="footer" v-if="headersLoading===false">
              <span :class="{'text-success mr-2':headerData.sites_scraped_last_week.increasing === true,'text-danger mr-2':headerData.sites_scraped_last_week.increasing === false}">
                <i :class="{'ni ni-bold-up':headerData.sites_scraped_last_week.increasing === true, 'ni ni-bold-down':headerData.sites_scraped_last_week.increasing === false, 'ni ni-fat-delete' : headerData.sites_scraped_last_week.increasing === null}"/>
                {{headersLoading ? '-' : headerData.sites_scraped_last_week.percent_change + ' %'}}
              </span>
              <span class="text-nowrap">Since last week</span>
            </template>
          </stats-card>
        </b-col>
      </b-row>
    </base-header>

    <b-container fluid class="mt--7">
      <b-row class="mb-3">
        <b-col xl="12" class="mb-5 mb-xl-0">
          <card>
            <popularity-filters name="main" @change="filterChanged" />
            <b-button variant="success" @click="getCharts()">Filter</b-button>
          </card>
        </b-col>
      </b-row>
      <template>
      <b-row>  
        <b-col xl="6" class="mb-5 mb-xl-0">
          <card header-classes="bg-transparent">
            <b-row align-v="center" slot="header">
              <b-col>
                <h6 class="text-uppercase ls-1 mb-1">Frequency overview - Line</h6>
              </b-col>
              <b-col>
                <b-nav class="nav-pills justify-content-end">
                  <b-nav-item
                       class="mr-2 mr-md-0"
                       :active="charts.frequencyLine.active==='current'"
                       link-classes="py-2 px-3"
                       @click.prevent="initChart('frequencyLine','frequency','current',null)">
                      <span class="d-none d-md-block">Current</span>
                  </b-nav-item>
                  <b-nav-item
                    link-classes="py-2 px-3"
                    :active="charts.frequencyLine.active==='average'"
                    @click.prevent="initChart('frequencyLine','frequency','average',null)"
                  >
                    <span class="d-none d-md-block">Average</span>
                  </b-nav-item>
                </b-nav>
              </b-col>
            </b-row>
            <p v-if="chartsLoading.hourly_weekdays_average">Loading...</p>
            <canvas v-else id="frequencyLine" ref="frequencyLine" :width="charts.frequencyLine.width" :height="charts.frequencyLine.height" />
          </card>
        </b-col>

        <b-col xl="6" class="mb-5 mb-xl-0">
          <card header-classes="bg-transparent" body-classes="p-2">
            <b-row align-v="center" slot="header">
              <b-col>
                <h6 class="text-uppercase ls-1 mb-1">Frequency overview - Heatmap</h6>
              </b-col>
              <b-col>
                <b-nav class="nav-pills justify-content-end">
                  <b-nav-item
                       class="mr-2 mr-md-0"
                       :active="charts.frequencyHeatmap.active==='current'"
                       link-classes="py-2 px-3"
                       @click.prevent="initChart('frequencyHeatmap','frequency','current',null)">
                      <span class="d-none d-md-block">Current</span>
                  </b-nav-item>
                  <b-nav-item
                    link-classes="py-2 px-3"
                    :active="charts.frequencyHeatmap.active==='average'"
                    @click.prevent="initChart('frequencyHeatmap','frequency','average',null)"
                  >
                    <span class="d-none d-md-block">Average</span>
                  </b-nav-item>
                </b-nav>
              </b-col>
            </b-row>
            <p v-if="chartsLoading.hourly_weekdays_average">Loading...</p>
            <canvas v-else id="frequencyHeatmap" ref="frequencyHeatmap" :width="charts.frequencyHeatmap.width" :height="charts.frequencyHeatmap.height" />
          </card>
        </b-col>
      </b-row>
      <br>
      <b-row v-if="showAddCombinedFilters">
        <b-col xl="12" class="mb-5 mb-xl-0">
          <card header-classes="bg-transparent" class="row">
            <popularity-filters name="combined" @change="filterChanged" />
            <base-input :label="'New data label'" :placeholder="'New data label'" type="text" v-model="combinedLineNewDataLabel" />
            <b-button variant="success" @click="addChartToCombined()">Add to combined chart</b-button>
          </card>
        </b-col>
      </b-row>
      <br>
      <b-row>
        <b-col xl="12" class="mb-5 mb-xl-0">
          <card header-classes="bg-transparent">
            <b-row align-v="center" slot="header">
              <b-col>
                <h6 class="text-uppercase ls-1 mb-1">Combined Chart</h6>
              </b-col>
              <b-col>
                <br>
                <b-nav class="nav-pills justify-content-end">
                  <b-nav-item
                    link-classes="py-2 px-3"
                    :active="charts.combinedLine.span==='daily'"
                    @click.prevent="initChart('combinedLine','combined',null,'daily')"
                  >
                    <span class="d-none d-md-block">Daily</span>
                  </b-nav-item>
                  <b-nav-item
                    link-classes="py-2 px-3"
                    :active="charts.combinedLine.span==='hourly'"
                    @click.prevent="initChart('combinedLine','combined',null,'hourly')"
                  >
                    <span class="d-none d-md-block">Hourly</span>
                  </b-nav-item>
                </b-nav>
              </b-col>
            </b-row>
            <b-row>
              <div class="dataset-header">
                <template v-if="chartData.combined.combined.daily !== null">
                  <div class="badge badge-success d-inline-flex align-items-center mr-1" v-for="(dataset,index) in chartData.combined.combined.daily.datasets" :key="index" @click="refreshFilters('combined',dataset)">
                    {{dataset.label}}
                    <span class="closebtn" @click="combinedDeleteDataset(index)">&times;</span>
                  </div>
                </template>
                <br>
                <base-button icon type="success" @click="showAddCombinedFilters=!(showAddCombinedFilters)">
                  <span class="btn-inner--icon">
                    <i class="ni ni-fat-add"/>
                  </span>
                </base-button>
              </div>
            </b-row>
            <p v-if="(chartsLoading.daily_average && charts.combinedLine.span==='daily') || (chartsLoading.hourly_average && charts.combinedLine.span==='hourly')">Loading...</p>
            <canvas v-else id="combinedLine" ref="combinedLine" :width="charts.combinedLine.width" :height="charts.combinedLine.height" />
          </card>
        </b-col>
      </b-row>
      </template>
    </b-container>

  </div>
</template>
<script>
import StatsCard from '@/components/Cards/StatsCard';

import PopularityFilters from '@/components/PopularityFilters';

import chartjs from 'chart.js';
import heatmap from 'chart.heatmap.js';

import RepositoryFactory from '@/repositories/RepositoryFactory';

const PopularitySiteRepository = RepositoryFactory.get('popularity_site')
const PopularityDataRepository = RepositoryFactory.get('popularity_data')
const CountryRepository = RepositoryFactory.get('country')

export default {
  components: {
    StatsCard,
    [PopularityFilters.name]:PopularityFilters
  },
  data() {
    return {
      filters:{
        main:{},
        combined:{},
      },
      showAddCombinedFilters:false,

      datePickerOptions:{
        format: 'MM/DD/YYYY',
        useCurrent: false,
        showClear: true,
        showClose: true,
        showTodayButton:true,
      },

      combinedLineNewDataLabel:'New data',

      charts:{
        frequencyLine:{
          width:300,
          height:192,
          active:null,
          span:null,
          chart:null,
          chartType:'line',
          options:{
            scales: {
              yAxes: [{
                display: true,
                ticks: {
                  suggestedMin: 0,
                  suggestedMax: 100,
                }
              }]
            },
            hoverBackgroundColor:'rgb(0,0,0)'
          },
        },
        frequencyHeatmap:{
          width:600,
          height:400,
          active:null,
          span:null,
          chart:null,
          chartType:'heatmap',
          options:{
             colors:['rgba(245,247,250,0.9)','rgba(205,33,38,0.9)']
          }
        },
        combinedLine:{
          width:700,
          height:350,
          active:null,
          span:null,
          chart:null,
          chartType:'line',
          options:{
            responsive:true,
            scales: {
              yAxes: [{
                display: true,
                ticks: {
                  suggestedMin: 0,
                  suggestedMax: 100,
                }
              }]
            },
            hoverBackgroundColor:'rgb(0,0,0)',
          },
        },
      },
      chartData:{
        frequency:{
          current:{
            daily:null,
            hourly:null,
          },
          average:{
            daily:null,
            hourly:null,
          }
        },
        combined:{
          combined:{
            daily:null,
            average:null,
          },
        }
      },
      chartTypes:{
        'hourly_weekdays_average':['week_day','hour'],
        'daily_average':['create_date__date'],
        'hourly_average':['create_date__date','hour'],
        'frequency_hourly':['hour'],
        'frequency_daily':['week_day'],
      },
      chartsLoading:{
        hourly_weekdays_average:false,
        daily_average:false,
        hourly_average:false,
      },

      headersLoading:true,
      headerData:null,

      autocompleteData:{
        combined:{},
        main:{},
      },

      countries:null,
      countriesLoading:true,
    };
  },

  mounted(){
    this.getCountries();
    this.getHeaderData();
    this.getCharts();
  },

  methods: {
    getCountries(){
      this.countriesLoading=true;
      CountryRepository.get().then((response) => {
        var data=response.data;
        this.countries={};
        for(var i in data){
          var d=data[i]
          this.countries[d.id]=d.name
        }
        this.countriesLoading=false;
      })
    },

    getHeaderData(){
      this.headersLoading=true
      PopularityDataRepository.getDashboardHeaders().then((response) => {
        this.headerData=response.data;
        for(var k in this.headerData){
          if(k=='next_scrape_date'){
            this.headerData[k]=this.timestampToDatetime(this.headerData[k]);
            continue
          }
          if(!(Number.isInteger(this.headerData[k].value)))
            this.headerData[k].value=this.headerData[k].value.toFixed(2);
          if(this.headerData[k].percent_change){
            this.headerData[k].increasing=this.headerData[k].percent_change>0 || this.headerData[k].percent_change==='Inf' 
              ? true : this.headerData[k].percent_change<0 || this.headerData[k].percent_change==='-Inf' 
              ? false : null;
            if(!(['Inf','-Inf'].includes(this.headerData[k].percent_change)) && !(Number.isInteger(this.headerData[k].percent_change)))
              this.headerData[k].percent_change=this.headerData[k].percent_change.toFixed(2);
          }
        }
        this.headersLoading=false;
      })
    },
    initChart(chartName,dataName,activeIndex,dateSpan){
      if(this.charts[chartName].chart!==null)
        this.charts[chartName].chart.destroy()
      dateSpan!==null ? this.charts[chartName].span=dateSpan : null;

      var data=null;
      if(Array.isArray(this.charts[chartName].active)){
        if(this.charts[chartName].active.includes(activeIndex)){
          this.charts[chartName].active.splice(this.charts[chartName].active.indexOf(activeIndex),1)
        }
        else if(activeIndex!==null){
          this.charts[chartName].active.push(activeIndex);
        }
        for(var i in this.charts[chartName].active){
          var dk=this.charts[chartName].active[i];
          if(data===null){
            data=this.copyObject(this.chartData[dataName][dk][this.charts[chartName].span]);
          }
          else{
            var j=0;
            var newData=this.copyObject(this.chartData[dataName][dk][this.charts[chartName].span]);
            var newLabelLen=newData.labels.length;
            var newDataOffset=0;
            while(j<newLabelLen){
              var newLabel=newData.labels[j-newDataOffset];
              var currentLabel=data.labels[j];
              if(newLabel!==currentLabel){
                if(newLabel<currentLabel){
                  data.labels.splice(j,0,newLabel);
                  for(var k in data.datasets){
                    data.datasets[k].data.splice(j,0,null);
                  }
                }
                else{
                  newData.datasets[0].data.splice(j,0,null);
                  newDataOffset++;
                  newLabelLen++;
                }
              }
              j++
            }
            for(var j in newData.datasets){
              data.datasets.push(this.copyObject(newData.datasets[j]));
            }
          }
        }
      }
      else{
        activeIndex!==null ? this.charts[chartName].active=activeIndex : null;
        data=this.copyObject(this.chartData[dataName][this.charts[chartName].active][this.charts[chartName].span]);
      }
      this.charts[chartName].chart=this.createChart(
        this.charts[chartName].chartType,
        data,
        this.$refs[chartName].getContext('2d'),
        this.charts[chartName].options,
        this.charts[chartName].plugins,
      );
      this.$forceUpdate();
    },
    createChart(type,data,context,options,plugins){
      if(type==='line'){
        var params={
          type:'line',
          data:data,
          options:options
        }
        if(plugins!==undefined){
          params.plugins=plugins
        }
        return new chartjs.Chart(
          context,
          params
        )
      }
        
      if(type==='heatmap'){
        return new heatmap(
          context
        ).HeatMap(data, options);
      }
    },
    filterChanged(newFilters){
      this.filters[newFilters.name]=newFilters.filters;
    },
    syncCombinedData(newData,active,span){
      var i=0;
      var newDataOffset=0;
      var newLabelLen=newData.labels.length;

      while(i<newLabelLen){
        var newLabel=newData.labels[i-newDataOffset];
        var currentLabel=this.chartData.combined[active][span].labels[i];
        if(newLabel!==currentLabel){
          if(newLabel<currentLabel || currentLabel===undefined){
            this.chartData.combined[active][span].labels.splice(i,0,newLabel);
            for(var j in this.chartData.combined[active][span].datasets){
              this.chartData.combined[active][span].datasets[j].data.splice(i,0,null);
            }
          }
          else{
            newData.datasets[0].data.splice(i+newDataOffset,0,null);
            newDataOffset++;
            newLabelLen++;
          }
        }
        i++
      }
      return newData.datasets[0];
    },
    combinedDeleteDataset(index){
      this.chartData.combined.combined.daily.datasets.splice(index,1);
      // this.chartData.combined.combined.daily.datasets.splice(index,1);

      this.chartData.combined.combined.hourly.datasets.splice(index,1);
      // this.chartData.combined.combined.hourly.datasets.splice(index,1);

      this.initChart('combinedLine','combined',null,null)
    },
    addChartsToPayload(chartNameList,payload){
      if(payload.charts===undefined)
        payload.charts={}

      for(var i in chartNameList){
        var chartName=chartNameList[i]
        var chartFields=this.chartTypes[chartName];

        payload.charts[chartName]=chartFields;
      }
      return payload
    },
    getHourlyWeekdaysAverageChart(init,currentOrAverage){
      if(init===true){
        this.chartsLoading.hourly_weekdays_average=true;
      }
      var hourlyWeekdaysAveragePayload=this.addChartsToPayload(['hourly_weekdays_average'],this.copyObject(this.filters.main));
      hourlyWeekdaysAveragePayload.current_value=currentOrAverage=='average' ? 0 : 1;

      PopularityDataRepository.getChart(hourlyWeekdaysAveragePayload).then((response) => {
          var hourlyWeekdaysAverageData=response.data.hourly_weekdays_average;

          this.chartData.frequency[currentOrAverage].daily=this.parseFrequencyWeekendData(hourlyWeekdaysAverageData,this.copyObject(this.filters.main));
          this.chartData.frequency[currentOrAverage].hourly=this.parseFrequencyData(hourlyWeekdaysAverageData,this.copyObject(this.filters.main));

          this.chartsLoading.hourly_weekdays_average=false;
          this.$nextTick(() => {
            if(init===true){
              this.initChart('frequencyLine','frequency',currentOrAverage,'daily');
              this.initChart('frequencyHeatmap','frequency',currentOrAverage,'hourly');
            }
          })
          
      })
    },
    getDailyAverageChart(init){
      if(init===true){
        this.chartsLoading.daily_average=true;
      }
      var dailyAveragePayload=this.addChartsToPayload(['daily_average'],this.copyObject(this.filters.main));
      dailyAveragePayload.current_value='all'

      PopularityDataRepository.getChart(dailyAveragePayload).then((response) => {
        var dailyAverageData=response.data.daily_average;
          
        this.chartData.combined.combined.daily=this.parseRecentDatesData(dailyAverageData.filter(e => e.current_value==1),'Main data (current)',this.randomRGB(),this.copyObject(this.filters.main))
        this.chartData.combined.combined.daily.datasets.push(this.syncCombinedData(this.parseRecentDatesData(dailyAverageData.filter(e => e.current_value==0),'Main data (average)',this.randomRGB(),this.copyObject(this.filters.main)),'combined','daily'))
        
        this.chartsLoading.daily_average=false;
        this.$nextTick(() => {
          if(init===true){
            this.initChart('combinedLine','combined','combined','daily');
          }
        })
        
      })
    },
    addDailyAverageChartToCombined(init){
      if(init===true){
        this.chartsLoading.daily_average=true;
      }
      var dailyAveragePayload=this.addChartsToPayload(['daily_average'],this.copyObject(this.filters.combined));
      dailyAveragePayload.current_value='all'

      PopularityDataRepository.getChart(dailyAveragePayload).then((response) => {
        var newDailyData=response.data;

        var newDailyCurrentData=this.parseRecentDatesData(newDailyData.daily_average.filter(e => e.current_value==1),(this.combinedLineNewDataLabel === '' ? 'Unnamed data' : this.combinedLineNewDataLabel)+' (current)',this.randomRGB(),this.copyObject(this.filters.combined))
        var newDailyAverageData=this.parseRecentDatesData(newDailyData.daily_average.filter(e => e.current_value==0),(this.combinedLineNewDataLabel === '' ? 'Unnamed data' : this.combinedLineNewDataLabel)+' (average)',this.randomRGB(),this.copyObject(this.filters.combined))

        this.chartData.combined.combined.daily.datasets.push(this.syncCombinedData(newDailyCurrentData,'combined','daily'));
        this.chartData.combined.combined.daily.datasets.push(this.syncCombinedData(newDailyAverageData,'combined','daily'));
        
        this.chartsLoading.daily_average=false;
        this.$nextTick(() => {
          if(init===true){
            this.initChart('combinedLine','combined','combined','daily');
          }
          else{
            this.initChart('combinedLine','combined',null,null)
          }
        })
      })
    },
    getHourlyAverageChart(init){
      if(init===true){
        this.chartsLoading.hourly_average=true;
      }
      var hourlyAveragePayload=this.addChartsToPayload(['hourly_average'],this.copyObject(this.filters.main));
      hourlyAveragePayload.current_value='all'

      PopularityDataRepository.getChart(hourlyAveragePayload).then((response) => {
        var hourlyAverageData = response.data.hourly_average
        this.chartData.combined.combined.hourly=this.parseRecentDatesHourlyData(hourlyAverageData.filter(e => e.current_value==1),'Main data (current)',this.randomRGB(),this.copyObject(this.filters.main))
        this.chartData.combined.combined.hourly.datasets.push(this.syncCombinedData(this.parseRecentDatesHourlyData(hourlyAverageData.filter(e => e.current_value==0),'Main data (average)',this.randomRGB(),this.copyObject(this.filters.main)),'combined','hourly'))

        this.chartsLoading.hourly_average=false;
        this.$nextTick(() => {
          if(init===true){
            this.initChart('combinedLine','combined','combined','hourly');
          }
        })
      })
    },
    addHourlyAverageChartToCombined(init){
      if(init===true){
        this.chartsLoading.hourly_average=true;
      }
      var hourlyAveragePayload=this.addChartsToPayload(['hourly_average'],this.copyObject(this.filters.main));
      hourlyAveragePayload.current_value='all'

      PopularityDataRepository.getChart(hourlyAveragePayload).then((response) => {
        var newHourlyAverageData=response.data.hourly_average;

        var newHourlyCurrentData=this.parseRecentDatesHourlyData(newHourlyAverageData.filter(e => e.current_value==1),(this.combinedLineNewDataLabel === '' ? 'Unnamed data' : this.combinedLineNewDataLabel)+' (current)',this.randomRGB(),this.copyObject(this.filters.combined))
        var newHourlyAverageData=this.parseRecentDatesHourlyData(newHourlyAverageData.filter(e => e.current_value==0),(this.combinedLineNewDataLabel === '' ? 'Unnamed data' : this.combinedLineNewDataLabel)+' (average)',this.randomRGB(),this.copyObject(this.filters.combined))

        this.chartData.combined.combined.hourly.datasets.push(this.syncCombinedData(newHourlyCurrentData,'combined','hourly'));
        this.chartData.combined.combined.hourly.datasets.push(this.syncCombinedData(newHourlyAverageData,'combined','hourly'));

        this.chartsLoading.hourly_average=false;
        this.$nextTick(() => {
          if(init===true){
            this.initChart('combinedLine','combined','combined','hourly');
          }
          else{
            this.initChart('combinedLine','combined',null,null)
          }
        })
      })
    },
    parseHourlyToDaily(hourlyData){
      var parsedData={};

      for(var i in hourlyData){
        var hourData=hourlyData[i];
        var createDate=hourData.create_date__date;
        var popularity=hourData.avg_popularity
        if(parsedData[createDate]===undefined){
          parsedData[createDate]={sum:popularity,count:1};
          continue
        }

        parsedData[createDate].sum+=popularity;
        parsedData[createDate].count+=1;
      }
      var returnValue=[];
      for(var createDate in parsedData){
        var popularity=parsedData[createDate].sum/parsedData[createDate].count;
        returnValue.push({create_date__date:createDate,avg_popularity:popularity});
      }
      return returnValue;
    },
    getCharts(){
      var payload=this.addChartsToPayload(['hourly_weekdays_average','hourly_average'],this.copyObject(this.filters.main));
      payload.current_value='all'

      this.chartsLoading.hourly_weekdays_average=true;
      this.chartsLoading.daily_average=true;
      this.chartsLoading.hourly_average=true;

      // Önceki verileri sildik
      this.chartData.frequency.current.daily=[];
      this.chartData.frequency.current.hourly=[];

      this.chartData.frequency.average.daily=[];
      this.chartData.frequency.average.hourly=[];

      this.chartData.combined.combined.daily=[];
      this.chartData.combined.combined.hourly=[]

      PopularityDataRepository.getChart(payload).then((response) => {
        var data=response.data;
        var currentData=data.current;
        var averageData=data.average;

        var hourlyWeekdaysCurrentData=currentData.hourly_weekdays_average;
        if(hourlyWeekdaysCurrentData.length>0){
          this.chartData.frequency.current.daily=this.parseFrequencyWeekendData(hourlyWeekdaysCurrentData,this.copyObject(this.filters.main));
          this.chartData.frequency.current.hourly=this.parseFrequencyData(hourlyWeekdaysCurrentData,this.copyObject(this.filters.main));
        }
        
        var hourlyWeekdaysAverageData=averageData.hourly_weekdays_average;
        if(hourlyWeekdaysAverageData.length>0){
          this.chartData.frequency.average.daily=this.parseFrequencyWeekendData(hourlyWeekdaysAverageData,this.copyObject(this.filters.main));
          this.chartData.frequency.average.hourly=this.parseFrequencyData(hourlyWeekdaysAverageData,this.copyObject(this.filters.main));
        }

        var hourlyCurrentData=currentData.hourly_average;
        var hourlyAverageData=averageData.hourly_average;

        if(hourlyCurrentData.length>0){
          this.chartData.combined.combined.hourly=this.parseRecentDatesHourlyData(hourlyCurrentData,'Main data (current)',this.randomRGB(),this.copyObject(this.filters.main));

          var dailyCurrentData=this.parseHourlyToDaily(hourlyCurrentData);
          this.chartData.combined.combined.daily=this.parseRecentDatesData(dailyCurrentData,'Main data (current)',this.randomRGB(),this.copyObject(this.filters.main))
          if(hourlyAverageData.length>0){
            var dailyAverageData=this.parseHourlyToDaily(hourlyAverageData);

            this.chartData.combined.combined.hourly.datasets.push(this.syncCombinedData(this.parseRecentDatesHourlyData(hourlyAverageData,'Main data (average)',this.randomRGB(),this.copyObject(this.filters.main)),'combined','hourly'));
            this.chartData.combined.combined.daily.datasets.push(this.syncCombinedData(this.parseRecentDatesData(dailyAverageData,'Main data (average)',this.randomRGB(),this.copyObject(this.filters.main)),'combined','daily'))
          }
        }
        else if(hourlyAverageData.length>0){
          this.chartData.combined.combined.hourly=this.parseRecentDatesHourlyData(hourlyAverageData,'Main data (average)',this.randomRGB(),this.copyObject(this.filters.main));

          var dailyAverageData=this.parseHourlyToDaily(hourlyAverageData);
          this.chartData.combined.combined.daily=this.parseRecentDatesData(dailyAverageData,'Main data (average)',this.randomRGB(),this.copyObject(this.filters.main))
        }

        // var dailyCurrentData=this.parseHourlyToDaily(hourlyCurrentData);
        // var dailyAverageData=this.parseHourlyToDaily(hourlyAverageData);
        // this.chartData.combined.combined.daily=this.parseRecentDatesData(dailyCurrentData,'Main data (current)',this.randomRGB(),this.copyObject(this.filters.main))
        // this.chartData.combined.combined.daily.datasets.push(this.syncCombinedData(this.parseRecentDatesData(dailyAverageData,'Main data (average)',this.randomRGB(),this.copyObject(this.filters.main)),'combined','daily'))

        this.chartsLoading.hourly_weekdays_average=false;
        this.chartsLoading.daily_average=false;
        this.chartsLoading.hourly_average=false;

        this.$nextTick(() => {
          this.initChart('frequencyLine','frequency','average','daily');
          this.initChart('frequencyHeatmap','frequency','average','hourly');
          this.initChart('combinedLine','combined','combined','daily');
        })
      })
    },
    addChartToCombined(){
      var payload=this.addChartsToPayload(['hourly_average'],this.copyObject(this.filters.combined));
      payload.current_value='all';

      this.chartsLoading.daily_average=true;
      this.chartsLoading.hourly_average=true;

      PopularityDataRepository.getChart(payload).then((response) => {
        var data=response.data;

        var newHourlyCurrentData=this.parseRecentDatesHourlyData(data.current.hourly_average,(this.combinedLineNewDataLabel === '' ? 'Unnamed data' : this.combinedLineNewDataLabel)+' (current)',this.randomRGB(),this.copyObject(this.filters.combined))
        var newHourlyAverageData=this.parseRecentDatesHourlyData(data.average.hourly_average,(this.combinedLineNewDataLabel === '' ? 'Unnamed data' : this.combinedLineNewDataLabel)+' (average)',this.randomRGB(),this.copyObject(this.filters.combined))

        this.chartData.combined.combined.hourly.datasets.push(this.syncCombinedData(newHourlyCurrentData,'combined','hourly'));
        this.chartData.combined.combined.hourly.datasets.push(this.syncCombinedData(newHourlyAverageData,'combined','hourly'));

        var newDailyCurrentData=this.parseRecentDatesData(this.parseHourlyToDaily(data.current.hourly_average),(this.combinedLineNewDataLabel === '' ? 'Unnamed data' : this.combinedLineNewDataLabel)+' (current)',this.randomRGB(),this.copyObject(this.filters.combined))
        var newDailyAverageData=this.parseRecentDatesData(this.parseHourlyToDaily(data.average.hourly_average),(this.combinedLineNewDataLabel === '' ? 'Unnamed data' : this.combinedLineNewDataLabel)+' (average)',this.randomRGB(),this.copyObject(this.filters.combined))

        this.chartData.combined.combined.daily.datasets.push(this.syncCombinedData(newDailyCurrentData,'combined','daily'));
        this.chartData.combined.combined.daily.datasets.push(this.syncCombinedData(newDailyAverageData,'combined','daily'));

        this.chartsLoading.daily_average=false;
        this.chartsLoading.hourly_average=false;

        this.combinedLineNewDataLabel='New data'

        this.$nextTick(() => {
          this.initChart('combinedLine','combined',null,null)
        })
      })
    },
    refreshFilters(filterName,dataset){
      this.filters[filterName]=dataset.filters;
      this.$forceUpdate();
    },
    parseFrequencyWeekendData(data,filters){
      var parsedData={
        labels:['0:00', '1:00', '2:00', '3:00', '4:00', '5:00', '6:00', '7:00', '8:00', '9:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'],
        datasets:[
          {
            label:'Weekday',
            backgroundColor:'rgba(255,255,255,0)',
            borderColor:'rgb(0, 123, 255)',
            pointBackgroundColor:'rgb(0, 123, 255)',
            filters:filters,
            data:[]
          },
          {
            label:'Weekend',
            backgroundColor:'rgba(255,255,255,0)',
            borderColor:'rgb(0, 255, 162)',
            pointBackgroundColor:'rgb(0, 255, 162)',
            filters:filters,
            data:[]
          }
        ]
      }
      for(var _ in parsedData.labels){
        parsedData.datasets[0].data.push({sum:0,count:0})
        parsedData.datasets[1].data.push({sum:0,count:0})
      }

      for(var i in data){
        var item=data[i];
        if(item.week_day<=5){
          parsedData.datasets[0].data[item.hour].sum+=parseInt(item.avg_popularity);
          parsedData.datasets[0].data[item.hour].count+=1;
        }
        else{
          parsedData.datasets[1].data[item.hour].sum+=parseInt(item.avg_popularity);
          parsedData.datasets[1].data[item.hour].count+=1;
        }
      }
      for(var i in parsedData.labels){
        parsedData.datasets[0].data[i]=parseInt(parsedData.datasets[0].data[i].sum/parsedData.datasets[0].data[i].count);
        parsedData.datasets[1].data[i]=parseInt(parsedData.datasets[1].data[i].sum/parsedData.datasets[1].data[i].count);
      }

      var removeIndexes=[0,1,2,3,4,5,6,23]

      removeIndexes.sort((a,b) => b-a);
      for(var i=0;i<removeIndexes.length;i++){
        var index=removeIndexes[i];
        parsedData.labels.splice(index,1)
        for(var j in parsedData.datasets){
          parsedData.datasets[j].data.splice(index,1)
        }
      }

      return parsedData;
    },
    parseFrequencyData(data,filters){
        var dayColors=[
          'rgb(255, 17, 0)',
          'rgb(255, 119, 0)',
          'rgb(255, 221, 0)',
          'rgb(183, 255, 0)',
          'rgb(0, 255, 162)',
          'rgb(0, 123, 255)',
          'rgb(132, 0, 255)'
        ]
        var parsedData={
          labels:['0:00', '1:00', '2:00', '3:00', '4:00', '5:00', '6:00', '7:00', '8:00', '9:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'],
          datasets:[]
        }

        for(var i in this.weekdays){
          var weekday=this.weekdays[i];
          var d=[];
          for(var _ in parsedData.labels){
            d.push(0);
          }
          parsedData.datasets.push({
            label:weekday,
            backgroundColor:'rgba(255,255,255,0)',
            borderColor:dayColors[i-1],
            pointBackgroundColor:dayColors[i-1],
            filters:filters,
            data:d
          });
        }

      for(var i in data){
        var item=data[i];
        parsedData.datasets[item.week_day-1].data[item.hour]=parseInt(item.avg_popularity)
      }

      var removeIndexes=[0,1,2,3,4,5,6,23]

      removeIndexes.sort((a,b) => b-a);
      for(var i=0;i<removeIndexes.length;i++){
        var index=removeIndexes[i];
        parsedData.labels.splice(index,1)
        for(var j in this.weekdays){
          j--;
          parsedData.datasets[j].data.splice(index,1)
        }
      }

      return parsedData;
    },
    parseRecentDatesData(data,label,dataColor,filters){
      data.sort((a,b) => a.create_date__date < b.create_date__date ? -1 : 1);
      var labels=[];
      var parsedData=[];
      for(var i in data){
        var d=data[i];
        labels.push(d.create_date__date);
        parsedData.push(parseInt(d.avg_popularity));
      }

      return {
        labels:labels,
        datasets:[
          {
            label:label,
            data:parsedData,
            backgroundColor:'rgba(255,255,255,0)',
            borderColor:dataColor,
            pointBackgroundColor:dataColor,
            filters:filters,
          }
        ]
      }
    },
    parseRecentDatesHourlyData(data,label,dataColor,filters){
      data.sort((a,b) => `${a.create_date__date} ${('0' + a.hour).slice(-2)}:00` < `${b.create_date__date} ${('0' + b.hour).slice(-2)}:00` ? -1 : 1)
      var labels=[];
      var parsedData=[];
      for(var i in data){
        var d=data[i];
        labels.push(d.create_date__date + ' ' + ('0' + d.hour).slice(-2) +':00');
        parsedData.push(parseInt(d.avg_popularity));
      }

      return {
        labels:labels,
        datasets:[
          {
            label:label,
            data:parsedData,
            backgroundColor:'rgba(255,255,255,0)',
            borderColor:dataColor,
            pointBackgroundColor:dataColor,
            filters:filters,
          }
        ]
      }
    },
  }
};
</script>
<style>
.el-table .cell{
  padding-left: 0px;
  padding-right: 0px;
}

.row {
  display:flex;
  flex-direction: row;
}

.dataset-header {
  display:flex;
  flex-direction: row;
  gap:1rem;
  flex-wrap: wrap;
}

</style>
